import { List, Create, Edit, View } from "../Components/index.js";

export default [
    {
        path: "/account/final-bill",
        component: List,
        name: "account.final-bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/final-bill/:id/view",
        component: View,
        name: "account.final-bill.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/final-bill/:id/edit",
        component: Edit,
        name: "account.final-bill.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/final-bill/create",
        component: Create,
        name: "account.final-bill.create",
        meta: {
            requiresAuth: true,
        },
    },
];
